import {IGetCustomLinkModalContentDataArgs, IGetCustomLinkTableDataArgs} from 'features/provide-custom-link/api/types';
import {
    TCustomLinkModalTableColumn,
} from 'features/provide-custom-link/model/types';
import {ELinkMethod} from 'shared/types/links';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

/**
 * Запрос для получения данных для CustomLinkModalTableView
 *
 * @param {number} id - ID записи для запроса данных
 * @param {TStateSetter<TCustomLinkModalTableColumn[] | undefined>} setColumns - Сеттер для столбцов таблицы
 * @param {TStateSetter<boolean>} setIsError - Сеттер для обновления статуса запроса
 * @param {TStateSetter<boolean>} setIsLoaded - Сеттер для обновления статуса загрузки
 *
 */
export const getCustomLinkTableData = async ({
    id, setColumns, setIsError, setIsLoaded,
}: IGetCustomLinkTableDataArgs) => {
    try {
        const {data} = await performRequest({
            url: `/custom-links/modal/${id}`,
            method: ERequestType.POST,
        }, true);

        if (data?.fields) {
            const cols: TCustomLinkModalTableColumn[] = data.fields;
            setColumns(cols.sort((a, b) => a.order - b.order));
        }
    } catch {
        setIsError(true);
    } finally {
        setIsLoaded(true);
    }
};

/**
 * Функция отправляет данные с token для микросервиса
 *
 * @param {ELinkMethod | null} url - Url для запроса
 * @param {ELinkMethod | null} method - Метод для запроса
 * @param {TLinkParameters | null} bodyParameters - Параметры для тела запроса
 * @param {TLinkParameters | null} queryParameters - Url-параметры для запроса
 * @param {boolean} isModalOpen - Открыто ли модальное окно
 * @param {string | null} token - Токен для микросервиса
 * @param {TStateSetter<boolean>} setIsError - Сеттер для обновления статуса запроса
 * @param {TStateSetter<boolean>} setLoading - Сеттер для обновления статуса загрузки
 *
 */
export const getCustomLinkModalContentData = async ({
    url,
    method,
    bodyParameters,
    queryParameters,
    isModalOpen,
    setData,
    token,
    setIsError,
    setIsLoaded,
}: IGetCustomLinkModalContentDataArgs) => {
    try {
        const {data} = await performRequest({
            url,
            method: method === ELinkMethod.GET ? 'GET' : 'POST', // todo: расширить
            data: (() => {
                if (bodyParameters) {
                    const formData = new FormData();
                    Object.entries(bodyParameters).forEach(([key, value]) => {
                        formData.set(key, value as string);
                    });
                    return formData;
                }
                return undefined;
            })(),
            params: (() => {
                if (method === ELinkMethod.GET && queryParameters) return queryParameters;
                return undefined;
            })(),
            headers: (() => {
                if (token) {
                    return {
                        Authorization: token,
                    };
                }
                return undefined;
            })(),
        });

        if (isModalOpen) {
            setData(data);
        }
    } catch {
        setIsError(true);
    } finally {
        setIsLoaded(true);
    }
};
